import { IBackendCartEntries } from '@rbi-ctg/menu';

export const maybeGetPickerIdFromCartEntry = (entry: IBackendCartEntries) => {
  const picker = entry.url?.split('/picker-')[1];
  return picker?.split('?')[0] ?? null;
};
